var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPointIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.873.662c3.4302406 0 6.211 2.78075942 6.211 6.211 0 3.4302406-2.7807594 6.211-6.211 6.211-3.43024058 0-6.211-2.7807594-6.211-6.211 0-3.43024058 2.78075942-6.211 6.211-6.211zm.727 3.496h-2.658v6.06h1.541v-1.778h1.02c1.349 0 2.277-.844 2.277-2.137 0-1.302-.882-2.146-2.18-2.146zm-.411 1.18c.646 0 1.033.34 1.033.97 0 .634-.387.974-1.042.974h-.697v-1.944z",
    fill: "#1c212b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPointIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/point_icon.e303ff7f9c3214c9b678033557918fde.svg";